// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type RoomTypeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RoomTypeQuery = { __typename?: 'Query', roomTypes: Array<{ __typename?: 'RoomType', id: string, name: string }> };


export const RoomTypeDocument = gql`
    query RoomType {
  roomTypes {
    id
    name
  }
}
    `;

/**
 * __useRoomTypeQuery__
 *
 * To run a query within a React component, call `useRoomTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoomTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RoomTypeQuery, RoomTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RoomTypeQuery, RoomTypeQueryVariables>(RoomTypeDocument, options);
      }
export function useRoomTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RoomTypeQuery, RoomTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RoomTypeQuery, RoomTypeQueryVariables>(RoomTypeDocument, options);
        }
// @ts-ignore
export function useRoomTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RoomTypeQuery, RoomTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RoomTypeQuery, RoomTypeQueryVariables>;
export function useRoomTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RoomTypeQuery, RoomTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RoomTypeQuery | undefined, RoomTypeQueryVariables>;
export function useRoomTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RoomTypeQuery, RoomTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RoomTypeQuery, RoomTypeQueryVariables>(RoomTypeDocument, options);
        }
export type RoomTypeQueryHookResult = ReturnType<typeof useRoomTypeQuery>;
export type RoomTypeLazyQueryHookResult = ReturnType<typeof useRoomTypeLazyQuery>;
export type RoomTypeSuspenseQueryHookResult = ReturnType<typeof useRoomTypeSuspenseQuery>;
export type RoomTypeQueryResult = Apollo.QueryResult<RoomTypeQuery, RoomTypeQueryVariables>;